import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // For navigation
import "./myTickets.css"; // Import the CSS file
import API from "../../../API";
import { useTranslation } from 'react-i18next'; // Import the translation hook

const MyTickets = () => {
  const { t } = useTranslation(); // Initialize the translation hook
  const userId = localStorage.getItem("userId");
  const [tickets, setTickets] = useState([]); // State to store tickets
  const [currentPage, setCurrentPage] = useState(1); // Pagination state
  const ticketsPerPage = 8; // Tickets per page
  const navigate = useNavigate(); // For navigation

  // Fetch tickets from the API
  useEffect(() => {
    const fetchTicket = async () => {
      const token = localStorage.getItem("protoken");
      if (!token) {
        console.error("No token found");
        return;
      }

      try {
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await API.get(`/support-tickets/user/${userId}`, config);
        setTickets(response.data); // Store the fetched tickets in state
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          console.error("Server responded with an error:", error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          console.error("No response received:", error.request);
        } else {
          // Something happened in setting up the request
          console.error("Error setting up the request:", error.message);
        }
      }
    };

    fetchTicket();
  }, [userId]);

  // Calculate the tickets to display on the current page
  const indexOfLastTicket = currentPage * ticketsPerPage;
  const indexOfFirstTicket = indexOfLastTicket - ticketsPerPage;
  const currentTickets = tickets.slice(indexOfFirstTicket, indexOfLastTicket);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total number of pages
  const totalPages = Math.ceil(tickets.length / ticketsPerPage);

  // Handle subject click to navigate to ticket details
  const handleSubjectClick = (ticketId) => {
    navigate(`/ticket/${ticketId}`); // Navigate to the ticket details page
  };

  return (
    <div className="my-tickets">
      <h2>{t("myTickets.title")}</h2>
      <table>
        <thead>
          <tr>
            <th>{t("myTickets.subject")}</th>
            <th>{t("myTickets.status")}</th>
            <th>{t("myTickets.last_message")}</th>
            <th>{t("myTickets.date")}</th>
          </tr>
        </thead>
        <tbody>
          {currentTickets.map((ticket) => {
            const lastMessage = ticket.messages[ticket.messages.length - 1]; // Get the last message
            const lastMessageDate = new Date(lastMessage?.created_at).toLocaleDateString(); // Format the date

            return (
              <tr key={ticket.id}>
                <td data-label={t("myTickets.subject")}>
                  <a
                    href={`/ticket/${ticket.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubjectClick(ticket.id);
                    }}
                  >
                    {ticket.subject}
                  </a>
                </td>
                <td data-label={t("myTickets.status")} data-status={ticket.state.toLowerCase()}>
                  {ticket.state}
                </td>
                <td data-label={t("myTickets.last_message")}>
                  {lastMessage
                    ? `${lastMessage.message.substring(0, 50)}...` // Show a snippet of the last message
                    : t("myTickets.no_messages")}
                </td>
                <td data-label={t("myTickets.date")}>{lastMessageDate}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("myTickets.previous_button")}
        </button>
        <span>
          {t("myTickets.page_info", { currentPage, totalPages })}
        </span>
        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          {t("myTickets.next_button")}
        </button>
      </div>
    </div>
  );
};

export default MyTickets;